module.exports = __webpack_public_path__ + "media/images/favicons/mstile-70x70-f3528dc5722aa6d5816539f9a586dc9a.png";